import React, { useState } from "react";
import MapView from "./MapView";

const CULTURES = [
  { annee: 2024, principale: "Maïs", couverture: "Ray-grass", norg: 1.2, fertilisation: "N 120kg/ha" },
  { annee: 2023, principale: "Blé", couverture: "Trèfle", norg: 1.4, fertilisation: "N 110kg/ha" },
  { annee: 2022, principale: "Soya", couverture: "Vesce", norg: 1.1, fertilisation: "N 80kg/ha" },
  { annee: 2021, principale: "Orge", couverture: "Moutarde", norg: 1.3, fertilisation: "N 100kg/ha" },
  { annee: 2020, principale: "Maïs", couverture: "Ray-grass", norg: 1.2, fertilisation: "N 120kg/ha" },
  { annee: 2019, principale: "Blé", couverture: "Trèfle", norg: 1.4, fertilisation: "N 110kg/ha" },
  { annee: 2018, principale: "Soya", couverture: "Vesce", norg: 1.1, fertilisation: "N 80kg/ha" },
  { annee: 2017, principale: "Orge", couverture: "Moutarde", norg: 1.3, fertilisation: "N 100kg/ha" },
  { annee: 2016, principale: "Maïs", couverture: "Ray-grass", norg: 1.2, fertilisation: "N 120kg/ha" },
  { annee: 2015, principale: "Blé", couverture: "Trèfle", norg: 1.4, fertilisation: "N 110kg/ha" }
];

const layers = [
  "Projet_MOS_Essai:BDPPAD_2015_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2016_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2017_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2018_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2019_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2020_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2021_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2022_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2023_MRC_MOS",
  "Projet_MOS_Essai:BDPPAD_2024_MRC_MOS"
];

export default function Historique({ onNavigate }) {
  const [activeLayer, setActiveLayer] = useState(layers[layers.length - 1]);
  const [visibleLayers, setVisibleLayers] = useState([layers[layers.length - 1]]);

  const handleLayerToggle = (layer) => {
    setVisibleLayers((prev) =>
      prev.includes(layer)
        ? prev.filter(l => l !== layer)
        : [...prev, layer]
    );
    setActiveLayer(layer);
  };

  return (
    <div style={{
      width: "100vw",
      minHeight: "100vh",
      maxWidth: "none",
      margin: 0,
      padding: "3em 0",
      background: "#f6f8f5",
      borderRadius: 0,
      position: "relative",
      boxShadow: "none",
      color: "#232b21"
    }}>
      <button
        style={{
          position: "absolute",
          top: "1em",
          left: "1em",
          padding: "0.5em 1.2em",
          background: "#7ca982",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
          zIndex: 100
        }}
        onClick={() => onNavigate("accueil")}
      >
        ← Retour à l’accueil
      </button>
      <div style={{ maxWidth: 1400, margin: "0 auto" }}>
        <h3 style={{ marginTop: "1.5em", fontSize: "1.4em", fontWeight: "bold" }}>Historique des cultures</h3>
        <h4 style={{ fontSize: "1em", color: "#39433a", marginBottom: "1em" }}>Liste cultures principales et de couverture (par année)</h4>
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "1em", fontSize: "1em" }}>
          <thead>
            <tr style={{ background: "#e3e8e1" }}>
              <th>Année</th>
              <th>Principale</th>
              <th>Couverture</th>
              <th>Norg (%)</th>
              <th>Fertilisation azotée</th>
            </tr>
          </thead>
          <tbody>
            {CULTURES.map(c => (
              <tr key={c.annee} style={{ background: "#fff" }}>
                <td>{c.annee}</td>
                <td>{c.principale}</td>
                <td>{c.couverture}</td>
                <td>{c.norg}</td>
                <td>{c.fertilisation}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <small style={{ color: "#555" }}>Sources : BD utilisateur, FADQ, AAC</small>
        <div style={{ marginTop: "2em" }}>
          <button
            style={{
              background: "#b7cbb2",
              color: "#39433a",
              fontWeight: "bold",
              padding: "0.7em 1.4em",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer"
            }}
            onClick={() => alert("Analyse de la tendance M.O. sur 10 ans")}
          >
            Analyse de la tendance M.O. sur 10 ans
          </button>
        </div>
        {/* Carte interactive avec superposition des couches */}
        <div style={{ marginTop: "2.5em", display: "flex", gap: "2em", alignItems: "flex-start" }}>
          <div style={{ minWidth: 260 }}>
            <h4 style={{ fontSize: "1em", marginBottom: "0.5em" }}>Couches cultures par année</h4>
            <ul style={{ fontSize: "0.95em", paddingLeft: 0, listStyle: "none" }}>
              {layers.map(layer => (
                <li key={layer} style={{ marginBottom: "0.4em" }}>
                  <label style={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
                    <input
                      type="checkbox"
                      checked={visibleLayers.includes(layer)}
                      onChange={() => handleLayerToggle(layer)}
                    />
                    <button
                      className={activeLayer === layer ? "active" : ""}
                      onClick={() => setActiveLayer(layer)}
                      style={{
                        marginLeft: "0.5em",
                        fontSize: "0.95em",
                        padding: "0.15em 0.7em",
                        background: activeLayer === layer ? "#b7cbb2" : "#e3e8e1",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer"
                      }}
                    >
                      {layer.split("_")[1]}
                    </button>
                  </label>
                </li>
              ))}
            </ul>
          </div>
          <div style={{ flex: 1, minWidth: 400, height: "650px", borderRadius: "12px", overflow: "hidden", boxShadow: "0 2px 8px #0001" }}>
            {/* Utilise bien visibleLayers pour MapView */}
            <MapView activeLayer={activeLayer} visibleLayers={visibleLayers} />
          </div>
        </div>
      </div>
    </div>
  );
}